export default __webpack_public_path__ + "media/src/assets/images/Location_v2-6a99787d9a4842e4614464a1059dacc5.svg";